var isBrowser = typeof window !== "undefined";
var Masonry = isBrowser ? window.Masonry || require("masonry-layout") : null;
var imagesloaded = isBrowser ? require("imagesloaded") : null;
var assign = require("lodash/assign");
var elementResizeDetectorMaker = require("element-resize-detector");
var debounce = require("lodash/debounce");
var omit = require("lodash/omit");
var PropTypes = require("prop-types");
var React = require("react");
var createReactClass = require("create-react-class");
var propTypes = {
  enableResizableChildren: PropTypes.bool,
  disableImagesLoaded: PropTypes.bool,
  onImagesLoaded: PropTypes.func,
  updateOnEachImageLoad: PropTypes.bool,
  options: PropTypes.object,
  imagesLoadedOptions: PropTypes.object,
  elementType: PropTypes.string,
  onLayoutComplete: PropTypes.func,
  onRemoveComplete: PropTypes.func
};
var MasonryComponent = createReactClass({
  masonry: false,
  erd: void 0,
  latestKnownDomChildren: [],
  displayName: "MasonryComponent",
  imagesLoadedCancelRef: void 0,
  propTypes,
  getDefaultProps: function() {
    return {
      enableResizableChildren: false,
      disableImagesLoaded: false,
      updateOnEachImageLoad: false,
      options: {},
      imagesLoadedOptions: {},
      className: "",
      elementType: "div",
      onLayoutComplete: function() {
      },
      onRemoveComplete: function() {
      }
    };
  },
  initializeMasonry: function(force) {
    if (!this.masonry || force) {
      this.masonry = new Masonry(
        this.masonryContainer,
        this.props.options
      );
      if (this.props.onLayoutComplete) {
        this.masonry.on("layoutComplete", this.props.onLayoutComplete);
      }
      if (this.props.onRemoveComplete) {
        this.masonry.on("removeComplete", this.props.onRemoveComplete);
      }
      this.latestKnownDomChildren = this.getCurrentDomChildren();
    }
  },
  getCurrentDomChildren: function() {
    var node = this.masonryContainer;
    var children = this.props.options.itemSelector ? node.querySelectorAll(this.props.options.itemSelector) : node.children;
    return Array.prototype.slice.call(children);
  },
  diffDomChildren: function() {
    var forceItemReload = false;
    var knownChildrenStillAttached = this.latestKnownDomChildren.filter(function(element) {
      return !!element.parentNode;
    });
    if (knownChildrenStillAttached.length !== this.latestKnownDomChildren.length) {
      forceItemReload = true;
    }
    var currentDomChildren = this.getCurrentDomChildren();
    var removed = knownChildrenStillAttached.filter(function(attachedKnownChild) {
      return !~currentDomChildren.indexOf(attachedKnownChild);
    });
    var newDomChildren = currentDomChildren.filter(function(currentChild) {
      return !~knownChildrenStillAttached.indexOf(currentChild);
    });
    var beginningIndex = 0;
    var prepended = newDomChildren.filter(function(newChild) {
      var prepend = beginningIndex === currentDomChildren.indexOf(newChild);
      if (prepend) {
        beginningIndex++;
      }
      return prepend;
    });
    var appended = newDomChildren.filter(function(el) {
      return prepended.indexOf(el) === -1;
    });
    var moved = [];
    if (removed.length === 0) {
      moved = knownChildrenStillAttached.filter(function(child, index) {
        return index !== currentDomChildren.indexOf(child);
      });
    }
    this.latestKnownDomChildren = currentDomChildren;
    return {
      old: knownChildrenStillAttached,
      // Not used
      new: currentDomChildren,
      // Not used
      removed,
      appended,
      prepended,
      moved,
      forceItemReload
    };
  },
  performLayout: function() {
    var diff = this.diffDomChildren();
    var reloadItems = diff.forceItemReload || diff.moved.length > 0;
    if (diff.removed.length > 0) {
      if (this.props.enableResizableChildren) {
        diff.removed.forEach(this.erd.removeAllListeners, this.erd);
      }
      this.masonry.remove(diff.removed);
      reloadItems = true;
    }
    if (diff.appended.length > 0) {
      this.masonry.appended(diff.appended);
      if (diff.prepended.length === 0) {
        reloadItems = true;
      }
      if (this.props.enableResizableChildren) {
        diff.appended.forEach(this.listenToElementResize, this);
      }
    }
    if (diff.prepended.length > 0) {
      this.masonry.prepended(diff.prepended);
      if (this.props.enableResizableChildren) {
        diff.prepended.forEach(this.listenToElementResize, this);
      }
    }
    if (reloadItems) {
      this.masonry.reloadItems();
    }
    this.masonry.layout();
  },
  derefImagesLoaded: function() {
    this.imagesLoadedCancelRef();
    this.imagesLoadedCancelRef = void 0;
  },
  imagesLoaded: function() {
    if (this.props.disableImagesLoaded) {
      return;
    }
    if (this.imagesLoadedCancelRef) {
      this.derefImagesLoaded();
    }
    var event = this.props.updateOnEachImageLoad ? "progress" : "always";
    var handler = debounce(
      function(instance) {
        if (this.props.onImagesLoaded) {
          this.props.onImagesLoaded(instance);
        }
        this.masonry.layout();
      }.bind(this),
      100
    );
    var imgLoad = imagesloaded(this.masonryContainer, this.props.imagesLoadedOptions).on(event, handler);
    this.imagesLoadedCancelRef = function() {
      imgLoad.off(event, handler);
      handler.cancel();
    };
  },
  initializeResizableChildren: function() {
    if (!this.props.enableResizableChildren) {
      return;
    }
    this.erd = elementResizeDetectorMaker({
      strategy: "scroll"
    });
    this.latestKnownDomChildren.forEach(this.listenToElementResize, this);
  },
  listenToElementResize: function(el) {
    this.erd.listenTo(el, function() {
      this.masonry.layout();
    }.bind(this));
  },
  destroyErd: function() {
    if (this.erd) {
      this.latestKnownDomChildren.forEach(this.erd.uninstall, this.erd);
    }
  },
  componentDidMount: function() {
    this.initializeMasonry();
    this.initializeResizableChildren();
    this.imagesLoaded();
  },
  componentDidUpdate: function() {
    this.performLayout();
    this.imagesLoaded();
  },
  componentWillUnmount: function() {
    this.destroyErd();
    if (this.props.onLayoutComplete) {
      this.masonry.off("layoutComplete", this.props.onLayoutComplete);
    }
    if (this.props.onRemoveComplete) {
      this.masonry.off("removeComplete", this.props.onRemoveComplete);
    }
    if (this.imagesLoadedCancelRef) {
      this.derefImagesLoaded();
    }
    this.masonry.destroy();
  },
  setRef: function(n) {
    this.masonryContainer = n;
  },
  render: function() {
    var props = omit(this.props, Object.keys(propTypes));
    return React.createElement(this.props.elementType, assign({}, props, { ref: this.setRef }), this.props.children);
  }
});
module.exports = MasonryComponent;
module.exports.default = MasonryComponent;
